import { render, staticRenderFns } from "./entertainment.vue?vue&type=template&id=77a85c4c&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77a85c4c')) {
      api.createRecord('77a85c4c', component.options)
    } else {
      api.reload('77a85c4c', component.options)
    }
    module.hot.accept("./entertainment.vue?vue&type=template&id=77a85c4c&", function () {
      api.rerender('77a85c4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/crash/entertainment.vue"
export default component.exports